import { useEffect } from "react";
import { useGame } from "../stores/useGame";
import { handleButtonActions } from "../utils/buttonActions";

export const useButtonHandler = () => {
  useEffect(() => {
    const handleKeyPress = (event) => {
      // Проверяем, что нажали Enter
      if (event.key === "Enter") {
        const state = useGame.getState();
        handleButtonActions(state);
      }
    };

    // Добавляем слушатель события
    window.addEventListener("keydown", handleKeyPress);

    // Убираем слушатель при размонтировании
    return () => {
      window.removeEventListener("keydown", handleKeyPress);
    };
  }, []);
};
